import qs, { type StringifyOptions } from 'query-string';

import { IModelMultiValuesFilters, IModelPriceFilters } from '@digital-dealer/types';

import RouteUrl from './routeUrl';
import sharedHistory from './sharedHistory';

export interface IModelChooserMultipleRouteParams extends Partial<IModelMultiValuesFilters> {}
export interface IModelChooserPriceRouteParams extends Partial<IModelPriceFilters> {}

export interface IModelChooserRouteParams extends IModelChooserMultipleRouteParams, IModelChooserPriceRouteParams {}

export const getModelChooserRoutePath = (): string => `/${RouteUrl.ModelChooser}`;

export const modelChooserRouteUrlStringifyOptions: StringifyOptions = { arrayFormat: 'bracket' };

export const getModelChooserRouteUrl = (params?: IModelChooserRouteParams): string => (
  `${getModelChooserRoutePath()}${params ? `?${qs.stringify(params, modelChooserRouteUrlStringifyOptions)}` : ''}`
);

export const goToModelChooserRoute = (params?: IModelChooserRouteParams): void => (
  sharedHistory.push(getModelChooserRouteUrl(params))
);

export interface IModelViewerRouteParams {
  modelCode: string;
}

export const getModelViewerRouteUrl = ({ modelCode }: IModelViewerRouteParams): string => (
  `/${RouteUrl.ModelViewer}/${modelCode}`
);

export const getModelViewerRoutePath = (): string => (
  `/${RouteUrl.ModelViewer}/:modelCode`
);

export const goToModelViewerRoute = (params: IModelViewerRouteParams): void => (
  sharedHistory.push(getModelViewerRouteUrl(params))
);

export interface IModelSoldOutRouteParams {
  modelCode?: string;
}

export const getModelViewerSoldOutRouteUrl = ({ modelCode }: IModelSoldOutRouteParams): string => (
  `/${RouteUrl.ModelViewer}/sold-out?${qs.stringify({ modelCode })}`
);

export const getModelViewerSoldOutRoutePath = (): string => (
  `/${RouteUrl.ModelViewer}/sold-out`
);

export const goToModelViewerSoldOutRoute = (params: IModelSoldOutRouteParams): void => (
  // Using `replace` here instead of `push` in order to avoid autoscrolling behavior
  sharedHistory.replace(getModelViewerSoldOutRouteUrl(params))
);

export const getModelViewerRestoreConfigRouteUrl = (): string => (
  `/${RouteUrl.ModelViewer}/restoreConfig`
);

export const getModelViewerRestoreConfigRoutePath = (): string => (
  `/${RouteUrl.ModelViewer}/restoreConfig`
);

export const goToModelViewerRestoreConfigRoute = (): void => (
  sharedHistory.push(getModelViewerRestoreConfigRouteUrl())
);

